import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// styles
import Link from "core/Link";
import { AuthorStyled } from "./styles";

const Author = () => {
    const { state } = useContext(AssetDownloadContext);

    const {
        asset: {
            creator: { username, name }
        }
    } = state;

    const creatorProfilePath = `/${encodeURIComponent(username)}/`;

    return (
        <AuthorStyled type="div" size="xs">
            <Link
                href={creatorProfilePath}
                size="xl"
                styleType="secondary"
                display="inline"
                darkMode
                disableVisitedStyle
                id="authorName"
            >
                {name}
            </Link>
        </AuthorStyled>
    );
};

export default Author;
